var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"border text-lg",attrs:{"show":"","variant":"success"}},[_c('p',{staticClass:"p-1"},[_vm._v(" Encontramos los siguientes medicamentos con disponibilidad 😃 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }